import type { PropsWithChildren } from "react";
import { useEffect } from "react";

import { DEV_AUTO_LOGIN_ACCOUNT, shouldAttemptDevAutoLogin } from "@/shared/api/auth.js";
import { loginWithPassword } from "@/shared/api/session.js";
import { useAuthStore } from "@/shared/stores/authStore.js";

export function AuthProvider({ children }: PropsWithChildren) {
  const hydrate = useAuthStore((state) => state.hydrate);
  const setSession = useAuthStore((state) => state.setSession);

  useEffect(() => {
    const controller = new AbortController();

    void (async () => {
      const user = await hydrate(controller.signal);
      if (controller.signal.aborted || user || !shouldAttemptDevAutoLogin()) return;

      try {
        const session = await loginWithPassword(DEV_AUTO_LOGIN_ACCOUNT);
        if (!controller.signal.aborted) setSession(session);
      } catch {
        // Dev auto-login is an opt-in convenience. Real auth prompts stay explicit.
      }
    })();

    return () => controller.abort();
  }, [hydrate, setSession]);

  return children;
}
